import tr_TR from '../../date-picker/locale/tr_TR'
export default tr_TR



// WEBPACK FOOTER //
// ./components/calendar/locale/tr_TR.js